export default __webpack_public_path__ + "static/media/tc-gears-line-min.600487e5.jpg";